import React from 'react';
import './index.scss';

const PostFormSection = ({ number, title, description, children }) => <section className="post-form-section">
  <div className="post-form-section-heading">
    <span>{number}</span>
    <div><h2>{title}</h2><p>{description}</p></div>
  </div>
  {children}
</section>;

export default PostFormSection;
